import { Component, OnInit, Input, AfterViewInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { NavigationEnd, NavigationStart, Router,Event as NavigationEvent } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'menu-partial',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input("classCustom") classCustom = "";
  @ViewChild("content") content:any;
  @Input("template") template = "default";
  public show       = false;
  public colecoes     = [];
  public dataColecoes = [];
  public showMenu     = false;
  public showMenu1    = false;
  public categorias   = [];
  public dataCategorias = [];

  constructor(
    private router: Router,
    private dataService: DataService
  ){ }
  
  /**
   * 
   * Navigate
   * 
   **/
  _navigate(url,apelido=null){

    if(apelido != null){
      url = url+"/"+apelido;
    }

    this.router.navigateByUrl(url);
    this._open();
    return false;

  }
  /**
   * 
   * Show menu
   * 
   */
   _showMenu1(){

    this.showMenu1 = this.showMenu1 ? false : true;

  }
  /**
   * 
   * Show menu
   * 
   */
  _showMenu(){

    this.showMenu = this.showMenu ? false : true;

  }
  /**
   * 
   * Open
   * 
   */
  _open(){

    if(this.show){

      this.content.nativeElement.classList.remove("show");
      this.show = false;

    }else{

      this.content.nativeElement.classList.add("show");
      this.show = true;

    }

  }
  /**
   * 
   * Set colecoes
   * 
   */
  setColecoes(){

    this.colecoes = this.dataService.getColecoes();

    let data   = [];
    let ul:any = [];
    let i      = 0;

    for (let index = 0;index < this.colecoes.length;index++) {
      
      if(i == 6){

        data.push(ul);
        i = 0;
        ul = [];
        ul.push(this.colecoes[index]);

      }else{

        ul.push(this.colecoes[index]);
        i++;

      }

      if(ul.length > 0 && ((this.colecoes.length-1) == index)){
        data.push(ul);
      }

    }

    this.dataColecoes = data;

  }
  /**
   * 
   * Categorias
   * 
   */
  setCategorias(){

    this.categorias = this.dataService.getCategoriasMenu(); 
    
    let data   = [];
    let ul:any = [];
    let i      = 0;

    for (let index = 0;index < this.categorias.length;index++) {
      
      if(i == 6){

        data.push(ul);
        i = 0;
        ul = [];
        ul.push(this.categorias[index]);

      }else{

        ul.push(this.categorias[index]);
        i++;

      }

      if(ul.length > 0 && ((this.categorias.length-1) == index)){
        data.push(ul);
      }

    }

    this.dataCategorias = data;

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{
    this.setColecoes();
    this.setCategorias();
  }

}
